import Sortable from "sortablejs";

/**
 * Entity Selector Popup
 * @extends {Component}
 */
class EntitySelectorExportPopup {

    setup() {
        this.elem = this.$el;
        this.selectButton = this.$refs.select;
        this.resetButton = this.$refs.reset;
        this.LoadButton = this.$refs.load;
        this.LoadButton.disabled = true;
        window.EntitySelectorExportPopup = this;
        this.callback = null;
        this.selection = null;
        this.selectedValues = [];
        this.submitUrl = window.baseUrl(`/ajax/mpdfexport`);
        this.selectButton.addEventListener('click', this.onSelectButtonClick.bind(this));
        window.$events.listen('entity-select-change', this.onSelectionChange.bind(this));
        window.$events.listen('entity-select-confirm', this.onSelectionConfirm.bind(this));
        this.resetButton.addEventListener('click', this.onResetButtonClick.bind(this));

        this.entitySelectorExport = this.elem.querySelector('[entity-selector-export]');
        const entityTypes = this.entitySelectorExport.hasAttribute('entity-types') ? this.entitySelectorExport.getAttribute('entity-types') : 'page,book,chapter';
        const entityPermission = this.entitySelectorExport.hasAttribute('entity-permission') ? this.entitySelectorExport.getAttribute('entity-permission') : 'view';
        const entitySlug = this.entitySelectorExport.hasAttribute('entity-slug') ? this.entitySelectorExport.getAttribute('entity-slug') : '';

        this.searchUrl = window.baseUrl(`/ajax/search/entities?for_export=yes&types=${encodeURIComponent(entityTypes)}&permission=${encodeURIComponent(entityPermission)}&slug=${encodeURIComponent(entitySlug)}`);

        this.loading = this.elem.querySelector('[entity-selector-loading]');
        this.resultsContainer = this.elem.querySelector('[entity-selector-export-results]');
    }

    show(callback) {
        this.callback = callback;
        this.elem.components.popup.show();
    }

    hide() {
        this.elem.components.popup.hide();
    }
    
    showLoading() {
        this.loading.style.display = 'block';
        this.resultsContainer.style.display = 'none';
        this.resultsContainer.innerHTML = "";
    }

    hideLoading() {
        this.loading.style.display = 'none';
        this.resultsContainer.style.display = 'block';
    }

    onResetButtonClick() {
        this.selectedValues = [];
        this.showLoading();

        window.$http.get(this.searchUrl).then(resp => {
            this.resultsContainer.innerHTML = resp.data;

            // initialize sorting functionality
            const initialSortBox = this.elem.querySelector('.sort-box');
            if (initialSortBox) {
                this.setupBookSortable(initialSortBox);
            }

            // enable checkbox parent-child checking
            let checkboxes = this.elem.querySelectorAll('.export-checkbox');
            let $this = this;
            checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener('change', function () {
                    if (this.classList.contains('checked')) {
                        if (typeof this.id != 'undefined' && this.id != "") {
                            let checkboxesChild = $this.elem.querySelectorAll('.' + this.id);
                            checkboxesChild.forEach(function (checkboxChild) {
                                checkboxChild.checked = false;
                                checkboxChild.classList.remove('checked');
                            })
                        }
                        else {
                            let checkboxesChild = $this.elem.querySelectorAll('.' + this.classList[1]);

                            let countCheckedChild = 0;
                            checkboxesChild.forEach(function (checkboxChild) {
                                if (checkboxChild.checked) {
                                    countCheckedChild++;
                                }
                            })

                            if (countCheckedChild == 0) {
                                let parentCheckboxId = this.classList[1];
                                let checkboxParent = $this.elem.querySelector('#' + parentCheckboxId);
                                if (checkboxParent) {
                                    checkboxParent.checked = false;
                                    checkboxParent.classList.remove('checked');
                                }
                            }
                        }
                        this.classList.remove('checked');
                    } else {
                        if (typeof this.id != 'undefined' && this.id != "") {
                            let checkboxesChild = $this.elem.querySelectorAll('.' + this.id);
                            checkboxesChild.forEach(function (checkboxChild) {
                                checkboxChild.checked = true;
                                checkboxChild.classList.add('checked');
                            })
                        }
                        else {
                            let parentCheckboxId = this.classList[1];
                            let checkboxParent = $this.elem.querySelector('#' + parentCheckboxId);
                            if (checkboxParent) {
                                checkboxParent.checked = true;
                                checkboxParent.classList.add('checked');
                            }
                        }
                        this.classList.add('checked');
                    }

                })
            });

            var acc = document.getElementsByClassName("export-popup-chapter-accordion");
            var i;
            for (i = 0; i < acc.length; i++) {
                acc[i].addEventListener("click", function () {
                    this.classList.toggle("active");
                    var panel = this.parentElement.nextElementSibling;
                    if (panel.style.display === "block") {
                        panel.style.display = "none";
                        this.innerHTML = '<i class="fa fa-angle-down" aria-hidden="true"></i>';
                    } else {
                        panel.style.display = "block";
                        this.innerHTML = '<i class="fa fa-angle-up" aria-hidden="true"></i>';
                    }
                });
            }

            this.hideLoading();
        })
    }

    onSelectButtonClick() {
        this.selectButton.style.display = 'none';
        this.LoadButton.style.display = 'block';

        let Switch = this.elem.querySelectorAll('.export-checkbox');

        for (let selectedElem of Switch) {
            if (selectedElem.classList.contains('checked')) {

                let pageRevisions = this.elem.querySelectorAll('.revision-dropdown' + selectedElem.getAttribute('value'));
                let revision = 0;
                for (let selectedRevision of pageRevisions) {
                    revision = selectedRevision.value;
                }

                let data = { 'id': selectedElem.getAttribute('value'), 'type': selectedElem.getAttribute('data-type'), 'slug': selectedElem.getAttribute('name'), 'revision': '' }
                if (selectedElem.getAttribute('data-type') == "page") {
                    data = { 'id': selectedElem.getAttribute('value'), 'type': selectedElem.getAttribute('data-type'), 'slug': selectedElem.getAttribute('name'), 'revision': revision}
                }

                this.selectedValues.push(data);
            }
        }

        let reqData = {
            id: this.selectedValues
        };
        window.$http.post(this.submitUrl, reqData).then(resp => {
            var fileURL = resp.data;
            var fileLink = document.createElement('a');
            fileLink.href = fileURL;
            var url = fileURL;
            var filename = url.substring(url.lastIndexOf('/')+1);
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);
            fileLink.click();
            // this.selectButton.disabled = false;

            this.LoadButton.style.display = 'none';
            this.selectButton.style.display = 'block';

            // this.uncheckAll();
            this.onResetButtonClick();
            this.hide();
        }).catch(err => {
            window.$events.showValidationErrors(err);
        });
      
    }

    onSelectionConfirm(entity) {
        this.hide();
        if (this.callback && entity) this.callback(entity);
    }

    onSelectionChange(entity) {
        this.selection = entity;
    }
    
    uncheckAll() {
        let checkboxes = this.elem.querySelectorAll('.export-checkbox');
        checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
            checkbox.classList.remove('checked');
        });
    }
    
    /**
     * Setup the given book container element to have sortable items.
     * @param {Element} bookContainer
     */
    setupBookSortable(bookContainer) {
        const sortElems = [bookContainer.querySelector('.sort-list')];
        sortElems.push(...bookContainer.querySelectorAll('.export-list-item-chapter + ul'));

        const bookGroupConfig = {
            name: 'book',
            pull: ['book', 'chapter'],
            put: ['book', 'chapter'],
        };

        const chapterGroupConfig = {
            name: 'chapter',
            pull: ['book', 'chapter'],
            put: function (toList, fromList, draggedElem) {
                return draggedElem.getAttribute('data-type') === 'page';
            }
        };

        for (let sortElem of sortElems) {
            new Sortable(sortElem, {
                group: sortElem.classList.contains('sort-list') ? bookGroupConfig : chapterGroupConfig,
                animation: 150,
                fallbackOnBody: true,
                swapThreshold: 0.65,
                // onSort: this.updateMapInput.bind(this),
                dragClass: 'bg-white',
                ghostClass: 'primary-background-light',
                multiDrag: true,
                multiDragKey: 'CTRL',
                selectedClass: 'sortable-selected',
            });
        }
    }
}

export default EntitySelectorExportPopup;
